export default "__VITE_ASSET__B$2Z$238__"